<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57 13h-6V7a2 2 0 00-2-2H15a2 2 0 00-2 2v6H7a2 2 0 00-2 2v34a2 2 0 002 2h6v6a2 2 0 002 2h34a2 2 0 002-2v-6h6a2 2 0 002-2V15a2 2 0 00-2-2zM16 8h32v5H16zm32 48H16V35h32zm8-8h-5V35h1.5a1.5 1.5 0 000-3h-41a1.5 1.5 0 000 3H13v13H8V16h48z"/><path d="M41.5 40h-19a1.5 1.5 0 000 3h19a1.5 1.5 0 000-3zM41.5 47h-19a1.5 1.5 0 000 3h19a1.5 1.5 0 000-3zM43 22.5a1.5 1.5 0 001.5 1.5h7a1.5 1.5 0 000-3h-7a1.5 1.5 0 00-1.5 1.5z"/></svg>